<template>
    <div class="content">
        <MultiLanguageContent>
            <template #th>
                <ContentDoc path="/th/cookie-policy" />
            </template>
            <template #en>
                <ContentDoc path="/cookie-policy" />
            </template>
        </MultiLanguageContent>
    </div>
</template>